export default __webpack_public_path__ + "static/media/favicon.86e63513.ico";